/* global jsVars */

import algoliasearch from 'algoliasearch/lite';
import { getAlgoliaResults } from '@algolia/autocomplete-js';
import debouncePromise from '../util/debouncePromise';

const debounced = debouncePromise((items) => Promise.resolve(items), 300);

export const searchbarProducts = {
  getSources() {
    const appId = jsVars.algolia.applicationId;
    const apiKey = jsVars.algolia.searchOnlyPublicApiKey;
    const searchClient = algoliasearch(appId, apiKey);

    return debounced([
      {
        sourceId: 'wc-products',
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: 'wp_searchable_posts', // Temporarily replaced 'wp_posts_product' with 'wp_searchable_posts', as the original index doesn't seem to contain all the products
                query,
                params: {
                  hitsPerPage: 2,
                },
                filters: `post_type: product`, // Filter out everything except products. Note: For future reference, you can use "lang:${jsVars.currentLanguage}" to filter by language
              },
            ],
          });
        },
        templates: {
          header() {
            return jsVars.translations.products;
          },
          item({ item, components, html }) {
            const product = {
              id: item.post_id,
              name: item.post_title,
              permalink: item.permalink,
              attributes: [],
              brands: [],
              thumbnail: '',
              stock_status: '',
              labels: [],
            };

            if (item.images.thumbnail) product.thumbnail = item.images.thumbnail.url;

            if (item.product_new_arrival) product.labels.push(jsVars.translations.newArrival);
            if (item.product_best_seller) product.labels.push(jsVars.translations.bestSeller);
            if (item.product_best_value) product.labels.push(jsVars.translations.bestValue);

            let stockStatusClass = '';
            switch (item.stock_status) {
              case 'instock':
                product.stock_status = jsVars.translations.inStock;
                stockStatusClass = 'in-stock';
                break;
              case 'outofstock':
                product.stock_status = jsVars.translations.outOfStock;
                stockStatusClass = 'out-of-stock';
                break;
              case 'onbackorder':
                product.stock_status = jsVars.translations.onBackorder;
                stockStatusClass = 'on-backorder';
                break;
              default:
                break;
            }

            // Get the brands
            if (item.taxonomies.product_manufacturer) {
              item.taxonomies.product_manufacturer.forEach((brand) => {
                product.brands.push(brand);
              });
            }

            // Filter out all taxonomies that don't start with 'pa_'
            const attributes = Object.keys(item.taxonomies).filter((key) => key.startsWith('pa_'));
            // For each attribute, loop over each value item
            attributes.forEach((attribute) => {
              item.taxonomies[attribute].forEach((value) => {
                // Apply any necessary transformations to the attribute name and value
                const cleanAttributeName = attribute.replace('pa_', '');
                const cleanValue = value;

                // Push the attribute to the product object
                product.attributes.push({
                  name: cleanAttributeName,
                  value: cleanValue,
                });
              });
            });

            // Turn attributes into a string
            const attributesString = product.attributes.map((attribute) => attribute.value).join(', ');

            return html`
              <a class="c-search-product-card js-searchbar-panel-product" href="${product.permalink}">
                <div class="card-tags">
                  ${product.labels.map((label) => html`<li class="tag"><span class="tag__label">${label}</span></li>`)}
                </div>
                <div class="card-inner">
                  <div class="card-top">
                    <div class="image">
                      ${product.thumbnail ? html`<img src="${product.thumbnail}" alt="${product.name}" />` : ''}
                    </div>
                  </div>
                  <div class="card-body">
                    <h3 class="name">${components.Highlight({ hit: item, attribute: 'post_title' })}</h3>
                  </div>
                  <div class="card-brands">
                    ${product.brands.map((brand) => html`<span class="brand">${brand}</span>`)}
                  </div>
                  <div class="c-product-card__attributes">${attributesString}</div>
                  <div class="card-bottom">
                    <div class="actions">
                      <div class="stock-status ${stockStatusClass}">
                        <span class="stock__label">${product.stock_status}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            `;
          },
          noResults() {
            return jsVars.translations.noProducts;
          },
        },
      },
    ]);
  },
};



// WEBPACK FOOTER //
// ./scripts/components/searchbar-products.js